import React, {Component} from "react";

export default class Intro extends Component {
    render() {
        return (
            <div style={{WebkitAppRegion: "drag"}}>
                <div className="welcome">
                    <div className="welcome-window">
                        <div className="redlike-logo-blue" />
                    </div>
                    <div className="footer" />
                </div>
            </div>
        );
    }
}
